import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import cn from 'classnames';

import './SubunitSummary.scss';
import SubunitIcon from '../SubunitIcon';

/**
 * Draws subunit summary
 * */
const SubunitSummary = ({ isLinkable, subject, unit, subunit }) => {
  const { displayName, highlight, number: subunitNumber, tags } = subunit;
  const { number: unitNumber } = unit;
  const tagText = tags && tags.length && tags.join(', ');

  let unitResource = displayName;
  if (subunit.target && subunit.target.length > 0) {
    unitResource = (
      <Link to={`${subunit.unitResourceURL}${subunit.target}`} target="_blank">
        {displayName}
      </Link>
    );
  }

  return (
    <div className="subunit-summary">
      <div data-id={subunit.id} className="subunit-title-line row-align-middle">
        <div className="subunit-icon">
          <SubunitIcon subunit={subunit} />
        </div>
        <span className={cn('subunit-name', highlight && 'highlight-subunit')}>
          {(isLinkable && (
            <Link
              to={`/${subject}/units/expand-unit/${unitNumber}/subunit/${subunitNumber}`}
            >
              {displayName}
            </Link>
          )) ||
            unitResource}
        </span>
      </div>
      {tagText && <span className="subunit-tags">{tagText}</span>}
    </div>
  );
};

SubunitSummary.displayName = 'SubunitSummary';

SubunitSummary.propTypes = {
  unit: PropTypes.object,
  subject: PropTypes.string,
  isLinkable: PropTypes.bool,
  subunit: PropTypes.object.isRequired,
};

SubunitSummary.defaultProps = {
  unit: {},
  isLinkable: false,
  subject: '',
};

export default SubunitSummary;

export { SubunitSummary };
